import { BackgroundOperationName, Query } from '../graphql';

export type BackgroundOperationCompletionConfig = {
  operationName: BackgroundOperationName;
  cacheKeysToEvict: (keyof Query)[];
  toastTitle: string;
  toastDescription: string;
};

export const BACKGROUND_OPERATION_COMPLETION_CONFIGS: BackgroundOperationCompletionConfig[] = [
  {
    operationName: BackgroundOperationName.ValidateTicketingFileOperation,
    cacheKeysToEvict: ['getCompany'],
    toastTitle: 'Successfully validated ticketing file!',
    toastDescription: 'The ticketing file has been validated successfully.',
  },
  {
    operationName: BackgroundOperationName.ApplyGithubEmailMappingOperation,
    // Both the company query and the upload list read through the getCompany root field.
    cacheKeysToEvict: ['getCompany'],
    toastTitle: 'Successfully applied GitHub emails!',
    toastDescription: 'The GitHub username to work email mapping has been applied.',
  },
  {
    operationName: BackgroundOperationName.ImportAscCostFileOperation,
    cacheKeysToEvict: ['getCompany', 'getAscWages', 'getAscWageSummary'],
    toastTitle: 'Successfully imported ASC cost file!',
    toastDescription: 'The ASC cost file has been imported successfully.',
  },
  {
    operationName: BackgroundOperationName.ImportRdCostFileOperation,
    cacheKeysToEvict: ['getFiscalYear', 'getPayrollQres', 'getPayrollQreSummary'],
    toastTitle: 'Successfully imported R&D cost file!',
    toastDescription: 'The R&D cost file has been imported successfully.',
  },
  {
    operationName: BackgroundOperationName.BulkRecalculateRdAllocationsOperation,
    cacheKeysToEvict: [
      'getFiscalYear',
      'getRdProjects',
      'getRdProjectsSummary',
      'getRdTaxCreditContributorsWithAllocation',
    ],
    toastTitle: 'Successfully recalculated R&D allocations!',
    toastDescription: 'The bulk R&D allocation recalculation has completed.',
  },
  {
    operationName: BackgroundOperationName.RegenerateRdProjectDetailsOperation,
    cacheKeysToEvict: ['getRdProjects', 'getRdProjectsSummary', 'getRdProject'],
    toastTitle: 'Project details updated!',
    toastDescription: 'The project details update has finished. The projects page is editable again.',
  },
  {
    operationName: BackgroundOperationName.MergeRdProjectsOperation,
    cacheKeysToEvict: ['getRdProjects', 'getRdProjectsSummary', 'getPayrollQres', 'getPayrollQreSummary'],
    toastTitle: 'Successfully merged R&D projects!',
    toastDescription: 'The R&D projects have been merged successfully.',
  },
  {
    operationName: BackgroundOperationName.GenerateFederalRdWriteupOperation,
    cacheKeysToEvict: ['getFiscalYear'],
    toastTitle: 'Successfully generated federal R&D write-up!',
    toastDescription: 'The federal R&D write-up has been generated successfully.',
  },
  {
    operationName: BackgroundOperationName.ApplyRdSupervisorAllocationOperation,
    cacheKeysToEvict: [
      'getPayrollQres',
      'getPayrollQreSummary',
      'getRdProjects',
      'getRdProjectsSummary',
      'getRdProjectTeamMembers',
      'getRdExpenseProjectAllocations',
    ],
    toastTitle: 'Successfully applied supervisor R&D percentages!',
    toastDescription: 'The supervisor R&D percentage allocations have been applied successfully.',
  },
  {
    operationName: BackgroundOperationName.GenerateAscReportOperation,
    cacheKeysToEvict: ['getLatestAscReportDocumentEvent'],
    toastTitle: 'ASC 350-40 documents are ready!',
    toastDescription:
      'Your generated documents are available to download next to Generate, and a copy has been emailed to you.',
  },
  {
    operationName: BackgroundOperationName.ImportAscProjectsFileOperation,
    cacheKeysToEvict: ['getAscProjects', 'getAscProjectsSummary'],
    toastTitle: 'Bulk project upload complete',
    toastDescription: 'Your projects have been created and are ready to view.',
  },
  {
    operationName: BackgroundOperationName.ImportRdProjectsFileOperation,
    cacheKeysToEvict: ['getRdProjects', 'getRdProjectsSummary'],
    toastTitle: 'Bulk project upload complete',
    toastDescription: 'Your projects have been created and are ready to view.',
  },
  {
    operationName: BackgroundOperationName.ImportRdBusinessComponentsFileOperation,
    cacheKeysToEvict: ['getRdBusinessComponentUploads'],
    // A rejected file also finishes the operation, so the toast reports completion, not success.
    toastTitle: 'Business components upload finished',
    toastDescription: 'Check Business Components on the Data Sources page for its status.',
  },
];
